import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function ObjectionsSection() {
  const faqs = [{
    question: '“Ya tengo mil cosas guardadas en TikTok.”',
    answer: 'Perfecto: te falta convertirlo en un sistema. Los vídeos sueltos inspiran, pero no organizan tu día a día. Esta guía hace exactamente eso: convierte el caos de información en un plan paso a paso.'
  }, {
    question: '“Me da miedo China por el idioma.”',
    answer: 'No necesitas hablar chino. Necesitas direcciones guardadas en chino (para enseñar), apps de traducción para resolver problemas puntuales y un plan de movilidad claro. El Kit Anti-Bloqueo te enseña a usar estas herramientas.'
  }, {
    question: '“¿Y si algo cambia?”',
    answer: 'Por eso el Kit Anti‑Bloqueo se basa en principios y checklists (lo que no cambia): backups, capturas offline, planes A/B. Las apps pueden actualizarse, pero la estrategia para no quedarte tirado es la misma.'
  }];
  return <section className="py-10 lg:py-20 px-4 sm:px-6 lg:px-8 bg-cream" data-id="element-188">
      <div className="max-w-3xl mx-auto" data-id="element-189">
        <h2 className="text-2xl lg:text-3xl font-bold text-charcoal text-center mb-8 lg:mb-12 font-serif" data-id="element-190">
          Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-191">
          {faqs.map((faq, index) => <AccordionItem key={index} question={faq.question} answer={faq.answer} data-id="element-192" />)}
        </div>
      </div>
    </section>;
}
function AccordionItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-xl shadow-sm border border-gold/20 overflow-hidden" data-id="element-193">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 flex justify-between items-center text-left focus:outline-none" data-id="element-194">
        <span className="font-serif font-semibold text-lg text-charcoal pr-4" data-id="element-195">
          {question}
        </span>
        <ChevronDown className={`h-5 w-5 text-gold transition-transform duration-300 ${isOpen ? 'transform rotate-180' : ''}`} data-id="element-196" />
      </button>
      <AnimatePresence data-id="element-197">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-198">
            <div className="px-6 pb-6 text-charcoal-light leading-relaxed border-t border-gray-100 pt-4" data-id="element-199">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}